import { render, staticRenderFns } from "./ObserverLive.vue?vue&type=template&id=2f424a07&scoped=true&"
import script from "./ObserverLive.vue?vue&type=script&lang=ts&"
export * from "./ObserverLive.vue?vue&type=script&lang=ts&"
import style0 from "./ObserverLive.vue?vue&type=style&index=0&id=2f424a07&prod&lang=scss&scoped=true&"
import style1 from "./ObserverLive.vue?vue&type=style&index=1&id=2f424a07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f424a07",
  null
  
)

export default component.exports